"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDisabledCapabilities = void 0;
const react_1 = require("react");
const CapabilityConfigurationProvider_1 = require("../components/CapabilityConfigurationProvider");
function useDisabledCapabilities() {
    const { disabledCapabilities, setDisabledCapabilities } = react_1.useContext(CapabilityConfigurationProvider_1.CapabilityContext);
    return [disabledCapabilities, setDisabledCapabilities];
}
exports.useDisabledCapabilities = useDisabledCapabilities;
//# sourceMappingURL=useDisabledCapabilities.js.map